import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaPinterestP,
  FaVimeoV,
} from "react-icons/fa";
import logo from "../../Asset/logo.jpg";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#111827]  text-white py-10">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-4 grid-cols-1 gap-8">
        {/* Company Info */}
        <div>
          <img src={logo} alt="logo" className="w-44" />
          <p className="text-gray-400 mt-4 text-sm leading-relaxed">
          CHARETHRI BUSINESS SOLUTIONS LLP is your trusted partner for all documentation and liaison  for your land and building needs.” Connect with us to make the process seamless and compliant.
          </p>

          {/* Social Media Icons */}
          <div className="flex space-x-4 mt-4 text-gray-400">
            <FaFacebookF className="hover:text-[#b7b7a1] cursor-pointer" />
            <FaTwitter className="hover:text-[#b7b7a1] cursor-pointer" />
            <FaLinkedinIn className="hover:text-[#b7b7a1] cursor-pointer" />
            <FaPinterestP className="hover:text-[#b7b7a1] cursor-pointer" />
            <FaVimeoV className="hover:text-[#b7b7a1] cursor-pointer" />
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-semibold mb-3">Quick Links</h3>
          <ul className="text-gray-400 space-y-2 text-sm">
            <li>
              <Link
                to="/"
                className="hover:text-[#b7b7a1] transition-colors duration-200"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="hover:text-[#b7b7a1] transition-colors duration-200"
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className="hover:text-[#b7b7a1] transition-colors duration-200"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/contact-us"
                className="hover:text-[#b7b7a1] transition-colors duration-200"
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="md:col-span-2">
          <h3 className="text-lg font-semibold  text-center mb-3">Contact Us</h3>

          <div className="flex flex-col md:flex-row md:space-x-8 space-y-6 md:space-y-0">
            {/* Head Office */}
            <div className="flex-1">
              <p className="text-gray-400 text-sm underline font-semibold">Head Office:</p>
              <p className="text-gray-400 text-sm">
                No: 4, BDA Complex, Koramangala 4th Block, Bangalore – 560034
              </p>
              <p className="text-gray-400 text-sm mt-2">
                E-mail: info@charethribs.com, contact@charethribs.com


              </p>
              <p className="text-gray-400 text-sm">
                Contact No: +91 9832444111, <br /> 080 49796720
              </p>
            </div>

            {/* Branch Office */}
            <div className="flex-1">
              <p className="text-gray-400 text-sm underline font-semibold">Branch Office:</p>
              <p className="text-gray-400 text-sm">
                Shop No; 16/A & B, No: 30, Basement, Sub-Registrar Office
                Building, K R Puram, Old Madras Road, Bangalore – 560036.
              </p>
              <p className="text-gray-400 text-sm mt-2">
                E-mail: info@charethribs.com, contact@charethribs.com
              </p>
              <p className="text-gray-400 text-sm">
                Contact No: +91 9902832233, <br />
                
                 +91 8618784279 
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="text-center text-gray-500 text-sm mt-8 border-t border-gray-700 pt-4">
        Privacy Policy | © 2025 Charethri Business Solutions. All rights
        reserved.
      </div>
    </footer>
  );
};

export default Footer;
